import {Button} from '~library/atoms/Button';
import {EditorHeader} from './EditorHeader';

export const EditorResetHeader = ({title, onReset, dataQaId, enabled = true}) => (
  <EditorHeader
    title={title}
    extra={
      <Button
        onClick={onReset}
        data-qa-id={dataQaId}
        variant="link"
        size="small"
        className="reset_all__button"
        disabled={!enabled}
      >
        Reset
      </Button>
    }
  />
);
